import styled from 'styled-components';
import { ReactSVG } from 'react-svg';

export const ToUploadList = styled.ul`
  margin: 16px 0;
  padding: 0;
  list-style: none;
`;

export const File = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  word-break: break-word;
  :last-child {
    margin-bottom: 0;
  }
`;

export const RemoveIcon = styled(ReactSVG)`
  margin-right: 10px;
  min-width: 16px;
  width: 16px;
  cursor: pointer;
  fill: ${({ theme }) => `${theme.colors.primaries.default}`};
`;

export const DownloadIcon = styled(RemoveIcon)`
  fill: #222222;
`;

export const FileHistoryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const FileHistoryTh = styled.th`
  text-align: left;
  border-bottom: 1px solid #ccc;
  padding: 8px;
`;

export const FileHistoryTd = styled.td`
  padding: 8px;
  border-bottom: 1px solid #eee;
`;